import { render, staticRenderFns } from "./chakanc.vue?vue&type=template&id=afe4560e&scoped=true&"
import script from "./chakanc.vue?vue&type=script&lang=js&"
export * from "./chakanc.vue?vue&type=script&lang=js&"
import style0 from "./chakanc.vue?vue&type=style&index=0&id=afe4560e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4560e",
  null
  
)

export default component.exports